import React, { useState, useEffect } from 'react';
import {  Dropdown, Image} from 'semantic-ui-react'
import { headerOption } from './reasonList';
import Images from '../config/images'
import PopUpIcon from '../formComponents/PopUpIcon'


const PscHeaderReason = (props) => {
    const [state, setState] = useState({
        PscHeader: false
    });
    const [selectedReason, setReason] = useState({
      selectedHeaderReason: props.selectedOptions
    });
    
    // const [onChangeCalled, setOnChangeCalled] = useState({
    //   onChangeCalled: false
    // });
    const [headerError, setHeaderError] = useState(false);
    // useEffect(() => {
    //   if(onChangeCalled.onChangeCalled && selectedReason.selectedHeaderReason && selectedReason.selectedHeaderReason.length === 0){
    //       onBlurReason();
    //       setOnChangeCalled({"onChangeCalled": false})
    //   }
    // }, [selectedReason]);

    
    const isTheOwningBroker = !props?.kxUserBasicInfo?.userGuid ||  !props?.currentJobData?.brokerGuid || props?.kxUserBasicInfo?.userGuid  == props?.currentJobData?.brokerGuid;
    const isPscDisableForm = !(props.pscState === 'STATE_PSC_IN_PROCESS' || props.pscState === 'STATE_PSC_READY');
    const pscDisabled = isPscDisableForm ? 'disableForm': '';
    const onChangeReason = (event, data) => {
      if(!isTheOwningBroker)return;
      setTimeout(()=>
       {document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();}
      ,100)
      let selectedReason = data.value;
      setHeaderError(false)
      if(props.totalHeaderReasonSelected === 5){
          if(!props.selectedOptions || !props.selectedOptions.length){
            setHeaderError(true)
            return;
          }
          else if(props.selectedOptions && props.selectedOptions.length){ 
            if(selectedReason.length > props.selectedOptions.length){
              setHeaderError(true)
              return;
            }
          } 
      } else if(((props.totalHeaderReasonSelected + selectedReason.length - props.selectedOptions) > 5)){
        setHeaderError(true)
        return;
      }
      if(!selectedReason.length){
        //setOnChangeCalled({"onChangeCalled": true})
        props.enableDisableFrom(false)
      }else{
        props.enableDisableFrom(true)
      }
      setReason({"selectedHeaderReason": selectedReason})
    }
    
    const handlePscState = (e) => {
      if(!isTheOwningBroker)return;
      let type = e.target.dataset.type; 
      setState({[type]: true})
      props.enableDisableFrom(true)
    }
    
    const cancelPsc = (e) => {
      let type = e.target.dataset.type;
      setState({[type]: false})
      props.enableDisableFrom(false)
    }

    const onBlurReason = (e) => {
      if(!isTheOwningBroker)return;
        let headerReason = selectedReason.selectedHeaderReason;
        let updatedReason = [];
        headerReason && headerReason.map((item)=>{
          let desc = headerOption.filter((_item)=> {
            return _item.key == item
          });
          
          updatedReason.push({
            "code": item, 
            "desc": desc[0]['description']
        })
      })
      props.saveHeaderReason(props.tabName, updatedReason);
    }
    if(props.pscState == "STATE_PSC_CANCELLED")return <></>;
      let noLineItemReasons = !state.PscHeader && (!props.selectedOptions || (props.selectedOptions && !props.selectedOptions.length));
      return (
      <div className={`psc-rect-box ${pscDisabled}`}>
      { 
          // (props.totalHeaderReasonSelected === 5 && (!props.selectedOptions || !props.selectedOptions.length)) ? 
          // <div className={`psc-rect-box ${pscDisabled}`}><div className='psc-dropdown-heading'>You have already selcted 5 header reasons</div></div> : 
          noLineItemReasons && 
          <div data-type="PscHeader" onClick={handlePscState} style={isTheOwningBroker?{}:{cursor:'not-allowed'}} className='add-a-psc-txt'>
            <Image src={Images.add_doc} /> Add a PSC header reason for this section.
            </div> 
      } 
            <div style={noLineItemReasons?{display:'none'}:{}}><div className='psc-dropdown-heading'>Add one or more reason for Post Summary Correction for this section. 
            <PopUpIcon icon='info circle' popupText={'You can select total of 5 header reasons'} /></div>
          <div>
          <Dropdown 
          lazyLoad={true}
          id='dom-header-reason' 
          data='dom-header-reason' 
          onChange={onChangeReason}
          onBlur={onBlurReason}
          placeholder='PSC Header Reasons' 
          fluid multiple selection 
          options={headerOption} 
          value={selectedReason.selectedHeaderReason || props.selectedOptions}
          style={{"width": "100%", "display":"inline-block"}}
          disabled={!isTheOwningBroker}
          /></div>
          {
            headerError && <div className='error'>You can select only 5 Header Reasons in total.</div>
          }
          </div>
      </div>);
    

}

export default PscHeaderReason;